// import $ from 'jquery';
// import 'what-input';

// // Foundation JS relies on a global variable. In ES6, all imports are hoisted
// // to the top of the file so if we used `import` to import Foundation,
// // it would execute earlier than we have assigned the global variable.
// // This is why we have to use CommonJS require() here since it doesn't
// // have the hoisting behavior.
// window.jQuery = $;
// require('foundation-sites');

// // If you want to pick and choose which modules to include, comment out the above and uncomment
// // the line below
// //import './lib/foundation-explicit-pieces';


// $(document).foundation();


// app.js new ...................................................................................


import $ from 'jquery';
import whatInput from 'what-input';
import waypoints from 'waypoints/lib/noframework.waypoints.min';
import slick from 'slick-carousel';
import AOS from 'AOS';
window.$ = $;
window.jQuery = $;

// require('aos');

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();





// init aos animation
AOS.init({
    duration: 1200,
})
// END init aos animation


// SCROLL SMOOTH
$('a[href^="#"]').click(function() {
    var the_id = $(this).attr("href");

    $('html, body').animate({
        scrollTop: $(the_id).offset().top
    }, 'slow');
    return false;
});
// END SCROLL SMOOTH

// BURGER
$('.material--burger').on('click', function() {
    $(this).toggleClass('material--arrow');
});
$(".navigation--button, .material--burger").click(function() {
    $(".menu").toggleClass("menu_visible");
    if ($(".menu_visible").css("width") == "490px") {
        console.log("490px");
        $(".modPopUp:nth-child(3n-2)").css('margin-left', '0');
    }
    return false;
});





// END BURGER


// slick
$(document).ready(function() {
    $('.first_slick').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});


$(document).ready(function() {
    $('.second_slick').slick({
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});




// waypoints
// $(document).ready(function(){
//   var waypoint = new Waypoint({ 
//     element: document.getElementById('waypoint'),
//     handler: function(direction) {

//       $(".icon-scroll").hide("slow");

//       $.each($('.img_each'), function(i, el){
//         setTimeout(function(){
//            $(el).addClass( "opacity" );
//         },200 + ( i * 250 ));
//       });

//     },
//     offset:'80%'
//   });

// });




google.maps.event.addDomListener(window, 'load', initialize);

